import React from 'react';
import { IoIosChatbubbles } from 'react-icons/io';
import propTypes from 'prop-types';
import { Link } from 'react-router-dom';

export default function BtnComments({ condominiumId, assemblyId, subjectId, comments }) {
  return (
    <Link
      role="button"
      to={`/condominiums/${condominiumId}/assembly/${assemblyId}/${subjectId}/comments`}
      style={{ fontSize: '1.2rem' }}
      className="float-right"
    >
      <IoIosChatbubbles />
      <small>
        {comments}
        <b>
          {' '}
          coment&aacute;rio
          {comments === 1 ? '' : 's'}
        </b>
      </small>
    </Link>
  );
}

BtnComments.propTypes = {
  condominiumId: propTypes.string.isRequired,
  assemblyId: propTypes.string.isRequired,
  subjectId: propTypes.string.isRequired,
  comments: propTypes.number.isRequired,
};
